/**
 * Force HTML5 constraint validation bubbles to English.
 * Browser-native tooltips follow the browser UI language (e.g. zh-CN →
 * "请填写此字段。"), not the store locale. Override via setCustomValidity.
 */
(function () {
  if (window.__jwEnglishValidation) return;
  window.__jwEnglishValidation = true;

  /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} el
   * @returns {string}
   */
  function englishMessage(el) {
    var v = el.validity;
    if (!v || v.valid) return '';

    var type = (el.getAttribute('type') || el.type || '').toLowerCase();
    var label = (el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.name || '').toLowerCase();
    var isEmail = type === 'email' || label.indexOf('email') !== -1;

    if (v.valueMissing) {
      if (isEmail) return 'Please enter your email address.';
      if (type === 'checkbox' || type === 'radio') return 'Please check this box if you want to proceed.';
      if (el.tagName === 'SELECT') return 'Please select an option.';
      return 'Please fill out this field.';
    }
    if (v.typeMismatch) {
      if (isEmail) return 'Please enter a valid email address.';
      if (type === 'url') return 'Please enter a valid URL.';
      return 'Please enter a valid value.';
    }
    if (v.patternMismatch) return 'Please match the requested format.';
    if (v.tooShort) {
      var min = el.getAttribute('minlength') || '';
      return min
        ? 'Please lengthen this text to ' + min + ' characters or more.'
        : 'Please lengthen this text.';
    }
    if (v.tooLong) {
      var max = el.getAttribute('maxlength') || '';
      return max
        ? 'Please shorten this text to ' + max + ' characters or fewer.'
        : 'Please shorten this text.';
    }
    if (v.rangeUnderflow) {
      var minVal = el.getAttribute('min');
      return minVal != null ? 'Please select a value that is no less than ' + minVal + '.' : 'Please enter a higher value.';
    }
    if (v.rangeOverflow) {
      var maxVal = el.getAttribute('max');
      return maxVal != null ? 'Please select a value that is no more than ' + maxVal + '.' : 'Please enter a lower value.';
    }
    if (v.stepMismatch) return 'Please enter a valid value.';
    if (v.badInput) return 'Please enter a valid value.';
    return 'Please enter a valid value.';
  }

  /**
   * @param {Event} event
   */
  function onInvalid(event) {
    var el = event.target;
    if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)) {
      return;
    }
    // Only override when the browser would otherwise show its locale bubble.
    if (typeof el.setCustomValidity !== 'function') return;
    el.setCustomValidity(englishMessage(el));
  }

  /**
   * @param {Event} event
   */
  function onClear(event) {
    var el = event.target;
    if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)) {
      return;
    }
    if (typeof el.setCustomValidity !== 'function') return;
    // Clear so the next invalid pass re-evaluates with a fresh English message.
    if (el.validationMessage) el.setCustomValidity('');
  }

  document.addEventListener('invalid', onInvalid, true);
  document.addEventListener('input', onClear, true);
  document.addEventListener('change', onClear, true);
})();
